import { ref } from "@vue/composition-api";
export const isSafari = ref(
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
);
